module.exports = require("node:util");